import {
  FETCH_ORDER_LIST_FILTER,
  RESET_ORDER_LIST_FILTER,
  FETCH_ORDER_LIST_CHIP_FILTER,
} from "../../constants/action.constants";

const initialState = {
  filters: {},
  chipFilters: [],
};

const orderListFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORDER_LIST_FILTER:
      return {
        ...state,
        filters: action.payload,
      };

    case FETCH_ORDER_LIST_CHIP_FILTER:
      return {
        ...state,
        chipFilters: action.payload,
      };

    case RESET_ORDER_LIST_FILTER:
      return initialState;

    default:
      return state;
  }
};

export default orderListFilterReducer;
